import urlConfig from '@/utils/config/interfaceConfig';
import Vue from 'vue';
import { refConfig } from './config/refConfig.js';
import PermissionManager from '../utils/permission';
import store from '@/store/index.js';

let isIOS;



const permissionManager = new PermissionManager(isIOS);

import * as Sentry from '@sentry/vue';


let apiUrl, webSiteUrl, plantId, refId, currentModule;
let globalData;
let apiRequestList = [];


const requestCompleteCallback = (res, requestUrl, requestParams, requestMethod) => {
  try {
    const statusCode = res.statusCode;
    let message = '';
    if (statusCode >= 400) {
      message = `HTTP ${statusCode} error`;
      const error = new Error(message);
      error.status = statusCode;
      Sentry.addBreadcrumb({
        category: 'http',
        message,
        data: {
          requestUrl,
          requestMethod,
          requestParams,
          response: res,
        },
      });
      throw error;
    } else if (statusCode === 200) {
      // .net
      let code = res.data.Code;
      let msg = res.data.Msg;
      // java
      if (!code) {
        code = res.data.code;
      }
      if (!msg) {
        msg = res.data.message;
      }
      // if (code && code !== '0000') {
      //   message = `API request failed, code: ${code}, message: ${msg}`;
      //   const error = new Error(message);
      //   error.status = statusCode;
      //   Sentry.addBreadcrumb({
      //     category: 'http',
      //     message,
      //     data: {
      //       requestUrl,
      //       requestMethod,
      //       requestParams,
      //       response: res,
      //     },
      //   });
      //   throw error;
      // }
    }
  } catch (error) {
    Sentry.captureException(error);
  }
};


function getUrlConfig() {
  //处理apiUrl & webSiteUrl

  let url = window.location.host;
  let urlArr = url.split('.');
  if (urlArr) {
    let flag = urlConfig.url.find((a) => (a.web || '').indexOf('https://' + url) >= 0);
    if (flag) {
      webSiteUrl = flag.web;
    }
  }

  if (!webSiteUrl) {
    // app 云打包默认为 production
    if (process.env.NODE_ENV === 'production') {
      webSiteUrl = 'https://m.ceekee.com'; //正式环境
    } else {
      // webSiteUrl = 'https://fatm.ceekee.com'; //测试环境
      //webSiteUrl = 'https://outfatm.ceekee.com'; //测试环境
      webSiteUrl = 'https://uatm.ceekee.com'; //预发环境
      // webSiteUrl = 'https://m.ceekee.com'; //正式环境
      // webSiteUrl = 'https://outuatm.ceekee.com'; //对外预发环境
      //webSiteUrl = "https://testdingding.ceekee.com";//钉钉环境
      //webSiteUrl = 'https://prodm.ceekee.com';//蓝色环境
      //webSiteUrl = 'https://feishu.ceekee.com';//飞书
      // webSiteUrl = 'https://dingding.ceekee.com/'; //钉钉应用市场
      //webSiteUrl = 'https://distribution.ceekee.com/'; //分销平台
    }
  }

  if (!currentModule || currentModule.length <= 0) {
    let flag = urlConfig.url.find((a) => a.web.indexOf(webSiteUrl) >= 0);
    apiUrl = flag.baseApi;
    currentModule = flag.modules;
    plantId = flag.plantId || '';
    refId = flag.refId || '';
    MemberInfo.PlatId = plantId || MemberInfo.PlatId;
    MemberInfo.RefId = refId || MemberInfo.RefId;
  } else {
    plantId = MemberInfo.PlatId;
  }
}

function getCurrentWebsiteUrl() {
  let currentWebsiteUrl = '';

  const { protocol, host } = window.location;
  host && (currentWebsiteUrl = `${protocol}//${host}/`);


  if (!currentWebsiteUrl) {
    // app 云打包默认为 production
    if (process.env.NODE_ENV === 'production') {
      currentWebsiteUrl = 'https://m.ceekee.com/'; //正式环境
    } else {
      // currentWebsiteUrl = 'https://fatm.ceekee.com'; //测试环境
      //currentWebsiteUrl = 'https://outfatm.ceekee.com'; //测试环境
      currentWebsiteUrl = 'https://uatm.ceekee.com/'; //预发环境
      // currentWebsiteUrl = 'https://m.ceekee.com/'; //正式环境
      // currentWebsiteUrl = 'https://outuatm.ceekee.com'; //对外预发环境
      //currentWebsiteUrl = "https://testdingding.ceekee.com";//钉钉环境
      //currentWebsiteUrl = 'https://prodm.ceekee.com';//蓝色环境
      //currentWebsiteUrl = 'https://feishu.ceekee.com';//飞书
      // currentWebsiteUrl = 'https://dingding.ceekee.com/'; //钉钉应用市场
      //currentWebsiteUrl = 'https://distribution.ceekee.com/'; //分销平台
    }

    // 以下是app端特殊平台环境的地址
    const agentPlatId = store.state.common.enterpriseInfo.agentPlatId;
    if (agentPlatId === '1001') {
      // 广东中旅
      currentWebsiteUrl = 'https://mtrip.gdcts.com/';
    }
  }
  return currentWebsiteUrl;
}

let MemberInfo = {
  EnterpriseId: '',
  Version: '8.00.10',
  MemberId: '',
  MemberName: '',
  PhoneType: '',
  MemberMac: '',
  Token: '',
  PlatId: 1020, //钉钉 1028 微信 1029 app 1020 企业微信服务商 1033 分销平台 1035 H5平台 1002
  RefId: '',
};

getUrlConfig();
//根据apiurl获取负载Apiurl
function getLoadBalancingApiUrl(module, address, key) {
  const enterpriseApiUrl = store.state.common.enterpriseInfo.apiUrl;
  const baseUrl = enterpriseApiUrl ? enterpriseApiUrl + '/' : apiUrl;
  // return apiUrl + module + '/' + address;
  return baseUrl + module + '/' + address;
}

let CustomerJurisdiction = {
  CanUse: false,
  IsPermittedUseCar: false,
  IsPermittedBookFlight: false,
  IsPermittedBookHotel: false,
  IsPermittedBookTrain: false,
  IsPermittedBookInternationalFlight: false,
  PermissionTypes: [],
  PermissionTypeConfigInfos: [],
  IsManage: 0,
  IsTrial: false,
};
let isInNoNetPage = false;
let isNoNet = false;
//默认用户
let defaultUser = {
  // MemberId: "2hFOqyccEbXYXHhhVlHD2A==", //线上测试MemberId
  // Token: "7b90d4df4ce94350cadd1228136abb7d" //线上测试Token
  MemberId: 'Y2ul2LiIceVxIVu7OOSDrA==', //线上
  Token: 'f8f83d45fb10e6f328b40e68ec8df000', //线上
};

let timeLongAPI = [];

//notFilteringParam 不再使用
//notHideLoding  是否隐藏loading  notFilteringParam 是否过滤唯一请求
export function Post(url, requestParam, callback, errorback, notHideLoding, notFilteringParam, needAbort = false) {



  let settings = GetSettings();
  let userInfo = settings.MemberInfo;
  let flag = false;
  let ikey = settings.EnterpriseKey || '';
  let requesturl = getLoadBalancingApiUrl(url.module, url.address, ikey);

  let requestTemp = {
    requesturl: requesturl,
    param: JSON.stringify(requestParam),
    needAbort: needAbort,
  };
  checkPostParam(requestTemp);
  let header = {};

  if (!requestParam.MemberId && !requestParam.Token) {
    if (!settings.isLogin && flag) {
      requestParam.MemberId = defaultUser.MemberId || '';
      requestParam.Token = defaultUser.Token || '';
    } else {
      if (settings.MemberInfo && settings.MemberInfo.MemberId) {
        requestParam.MemberId = settings.MemberInfo.MemberId || '';
        requestParam.Token = settings.MemberInfo.Token || '';
      }
    }
  }

  if (!requestParam.PlatId) {
    if (settings.platId) {
      requestParam.PlatId = settings.platId;
    } else {
      requestParam.PlatId = plantId || MemberInfo.PlatId;
    }
  }
  if (!requestParam.RefId) {
    if (settings.RefId) {
      requestParam.RefId = settings.RefId;
    } else {
      requestParam.RefId = refId || '0';
    }
  }
  // 如果外面穿传值就不传了
  if (!requestParam.IsTravelBussiness && requestParam.IsTravelBussiness !== 0) {
    requestParam.IsTravelBussiness = settings.bookingMethod != 0 ? 1 : 0;
  }
  if (settings.RefId == refConfig.dingdingjijian) {
    requestParam.IsTravelBussiness = 0;
  }

  requestParam.Version = MemberInfo.Version;
  requestParam.MemberMac = settings.MemberMac;
  requestParam.PhoneType = settings.PhoneType;
  let headerPlatId = getHeaderPlatId(settings.platId, plantId, MemberInfo.PlatId);
  // console.log("请求：" + requesturl + "=======>" + JSON.stringify(requestParam))
  if (isNoNet && !isInNoNetPage) {
    uni.navigateTo({
      url: '/components/netError',
    });
    isInNoNetPage = true;
    HideLoading();
    return;
  }
  //验证请求sessionId
  let sessionId = '';
  let reqId = getUUId();
  let globalData = getApp().globalData;
  if (globalData) {
    if (globalData.sessionId) {
      sessionId = globalData.sessionId;
    } else {
      sessionId = getUUId();
      globalData.sessionId = sessionId;
    }
  }
  let requestTask = uni.request({
    url: requesturl,
    data: JSON.stringify(requestParam),
    method: 'POST',
    header: {
      'Content-Type': 'application/json',
      sessionId: sessionId,
      reqId: reqId,
      ikey: ikey,
      MemberId: requestParam.MemberId || '',
      Token: requestParam.Token || '',
      PlatId: headerPlatId || '',
      RefId: requestParam.RefId || '',
    },
    success: (res) => {
      //console.log("返回：" + requesturl + "=======>" + JSON.stringify(res));
      if (res.data.Code == '8001' || res.data.Code == '8000') {
        setCustomerNull();
        if (requestParam.intervalTimer) {
          clearInterval(requestParam.intervalTimer);
        }
        if (!isSpecialPlat()) {
          // isInNoNetPage = true;
          uni.navigateTo({
            url: '/pages/loginAndRegister/login/login',
          });
        } else {
          Toast(res.data.Msg);
        }
        // Toast(res.data.Msg);
        // if (!notHideLoding) {
        HideLoading();
        // }
      } else if (callback) {
        if (!notHideLoding) {
          HideLoading();
        }
        callback(res.data);
      }
    },
    fail: (e) => {
      if (!notHideLoding) {
        HideLoading();
      }
      if (errorback) {
        errorback();
      }
    },
    complete: (res) => {

      requestCompleteCallback(res, url, requestParam, 'POST');

      deletePostParam(requestTemp);
    },
  });
  requestTemp.requestTask = requestTask;
  apiRequestList.push(requestTemp);
}

function getHeaderPlatId(settingPlatId, plantId, memberPlatId) {
  return settingPlatId || plantId || memberPlatId;
}

//notFilteringParam 不再使用
function request(url, requestParam, callback, errback, notHideLoding, notFilteringParam, needAbort = false) {
  let header = {};



  let requestType = url.method;
  let contentType = 'application/json';
  let settings = GetSettings();
  let userInfo = settings.MemberInfo;
  let flag = false;
  let ikey = settings.EnterpriseKey || '';
  let requesturl = getLoadBalancingApiUrl(url.module, url.address, ikey);

  let requestTemp = {
    requesturl: requesturl,
    param: JSON.stringify(requestParam),
    needAbort: needAbort || false,
  };
  checkPostParam(requestTemp);

  if (!settings.isLogin && flag) {
    header.MemberId = defaultUser.MemberId || '';
    header.Token = defaultUser.Token || '';
  } else {
    if (settings.MemberInfo && settings.MemberInfo.MemberId) {
      header.MemberId = settings.MemberInfo.MemberId || '';
      header.Token = settings.MemberInfo.Token || '';
    }
  }

  if (!header.MemberId || !header.Token) {
    HideLoading();
    return;
  }

  if (!requestParam.PlatId) {
    if (settings.platId) {
      header.PlatId = settings.platId;
    } else {
      header.PlatId = plantId || MemberInfo.PlatId;
    }
  } else {
    header.PlatId = requestParam.PlatId;
  }
  if (settings.RefId) {
    header.RefId = settings.RefId;
  } else {
    header.RefId = refId || '0';
  }
  header.Version = MemberInfo.Version;

  let baseParam = {
    MemberId: header.MemberId,
    Token: header.Token,
    PlatId: header.PlatId,
    RefId: header.RefId,
    Version: header.Version,
  };

  requestParam = {
    ...requestParam,
    ...baseParam,
  };

  // console.log("请求：" + requesturl + "=======>" + JSON.stringify(requestParam))
  if (isNoNet && !isInNoNetPage) {
    uni.navigateTo({
      url: '/components/netError',
    });
    isInNoNetPage = true;
    HideLoading();
    return;
  }
  //验证请求sessionId
  let sessionId = '',
    reqId = getUUId();
  let globalData = getApp().globalData;
  if (globalData) {
    if (globalData.sessionId) {
      sessionId = globalData.sessionId;
    } else {
      sessionId = getUUId();
      globalData.sessionId = sessionId;
    }
  }

  let requestTask = uni.request({
    url: requesturl,
    data: requestParam,
    method: requestType,
    header: {
      ...header,
      'Content-Type': contentType,
      sessionId: sessionId,
      ikey: ikey,
    },
    success: (res) => {
      //console.log("返回：" + requesturl + "=======>" + JSON.stringify(res));
      if (res.data.code == '8001' || res.data.code == '8000') {
        setCustomerNull();
        if (requestParam.intervalTimer) {
          clearInterval(requestParam.intervalTimer);
        }
        if (!isSpecialPlat()) {
          uni.navigateTo({
            url: '/pages/loginAndRegister/login/login',
          });
        }
        HideLoading();
      } else if (callback) {
        if (!notHideLoding) {
          HideLoading();
        }
        callback(res.data);
      }
    },
    fail: (e) => {
      if (!notHideLoding) {
        HideLoading();
      }
      if (errback) {
        errback();
      }
    },
    complete: (res) => {

      requestCompleteCallback(res, url, requestParam, 'POST');

      deletePostParam(requestTemp);
    },
  });

  requestTemp.requestTask = requestTask;
  apiRequestList.push(requestTemp);
}

function GetResultState(data) {
  if (data != undefined && data != null && (data.Code == '0000' || data.code == '0000')) {
    return true;
  } else {
    if (data.Code == '8001' && data.Code == '8000') {
      return;
    }
    return false;
  }
}

function hasNet() {
  let flag = true;
  uni.getNetworkType({
    success: (res) => {
      if (res.networkType != 'none') {
        flag = false;
      } else {
        flag = true;
      }
    },
    fail: () => {
      flag = true;
    },
  });
  isNoNet = flag;
}

function SerializeJson(self) {
  var o = {};
  var getClass = function (obj) {
    return Object.prototype.toString.call(obj).match(/^\[object\s(.*)\]$/)[1];
  };
  var init = function (value, name) {
    if (getClass(value) == 'Object') {
      for (var xtem in value) {
        if (name == null) {
          init(value[xtem], xtem.toString());
        } else {
          init(value[xtem], name + '.' + xtem.toString());
        }
      }
    } else if (getClass(value) == 'Number' || getClass(value) == 'String' || getClass(value) == 'Boolean') {
      o[name] = value;
    } else if (getClass(value) == 'Array') {
      for (var i = 0; i < value.length; i++) {
        init(value[i], name + '[' + i + ']');
      }
    }
  };
  init(self);
  return o;
}

function GetSettings() {
  let storage = uni.getStorageSync('settings');
  if (typeof storage == 'string') {
    return storage ? JSON.parse(storage) : {};
  } else {
    return storage || {};
  }
}

function SetSettings(settings) {
  uni.setStorageSync('settings', JSON.stringify(settings));
}

function getLocalStorage() {
  let settingsText = localStorage.getItem('settings') || '{}';
  return JSON.parse(settingsText).data || {};
}
//判断请求是否存在
function checkPostParam(param) {
  let index = apiRequestList.findIndex((x) => x.requesturl == param.requesturl);
  if (index >= 0 && apiRequestList[index].needAbort) {
    if (apiRequestList[index].requestTask) {
      apiRequestList[index].requestTask.abort();
    }
    apiRequestList.splice(index, 1);
  }
}

function deletePostParam(param) {
  let index = apiRequestList.findIndex((x) => x.requesturl == param.requesturl);
  if (index >= 0) {
    apiRequestList.splice(index, 1);
  }
}

function setLocalStorage(settings = {}) {
  let settingsText = localStorage.getItem('settings') || '{}';
  let set = JSON.parse(settingsText);
  set.data = settings;
  localStorage.removeItem('settings');
  localStorage.setItem('settings', JSON.stringify(set));
}

function Loading(val) {
  Vue.prototype.$loading({
    text: val || '',
  });









}

function HideLoading() {
  Vue.prototype.$loading({
    show: false,
  });



}

function Toast(val, icon) {
  if (isIos) {
    setTimeout(() => {
      showToast(val, icon);
    }, 60);
  } else {
    showToast(val, icon);
  }

  function showToast(val, icon) {
    icon = icon || 'none';
    uni.showToast({
      title: val,
      icon: icon,
      duration: 2000,
      position: 'bottom',
    });
  }
}

function Confirm(title, content, confirmText, cancelText, showCancel, callback) {
  uni.showModal({
    title: title.trim() || '提示',
    showCancel: showCancel || false,
    content: content,
    confirmText: confirmText,
    cancelText: cancelText || '',
    complete: callback,
  });
}
//身份证号正则
function checkCard(card) {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (reg.test(card) === false) {
    return false;
  }
  return true;
}

function checkPhone(phone) {
  if (/^1[0-9]{10}$/.test(phone)) {
    return true;
  } else {
    return false;
  }
}
//机票列表定时器
var timer = null;

function time(callback) {
  timer = setTimeout(() => {
    callback();
  }, 10 * 60 * 1000);
}

function clearTime() {
  if (time) {
    clearTimeout(timer);
  }
}
//火车票列表定时器
var timerTrain = null;

function timeTrain(callback) {
  timerTrain = setTimeout(() => {
    callback();
  }, 10 * 60 * 1000);
}

function clearTimeTrain() {
  if (timerTrain) {
    clearTimeout(timerTrain);
  }
}
var ModalHelper = (function (bodyCls) {
  var scrollTop;
  return {
    afterOpen: function () {},
    beforeClose: function () {},
  };
})('modal-open');

function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let param = window.location.search || window.location.hash;
  param = param.substr(param.indexOf('?') + 1);
  var r = param.match(reg);
  if (r != null) return decodeURI(r[2]).replace('#/', '');
  return null;
}

function SetTitleColor(type) {
  // 0黑色  1白色
  if (type == 0) {
    uni.setNavigationBarColor({
      frontColor: '#000000',
      backgroundColor: '#328bef',
    });
  } else if (type == 1) {
    uni.setNavigationBarColor({
      frontColor: '#ffffff',
      backgroundColor: '#328bef',
    });
  }
}

function SetBarTitle(title) {
  uni.setNavigationBarTitle({
    title: title,
  });
}
// 酒店入住人姓名验证
function checkName(name) {
  // var reg1 = /[\u4e00-\u9fa5]/g;
  // var reg2 = /[a-zA-Z]/g;
  // var cname = name.match(reg1);
  // var ename = name.match(reg2);
  // let length = 0;
  // if (name.indexOf('·') >= 0) {
  // 	length += 1;
  // }
  // if (cname == null) {
  // 	if (name.indexOf("/") >= 0) {
  // 		var temp = name.replace('/', "").replace(/\s+/g, "");
  // 		if (ename != null && ename.length == temp.length) {
  // 			return true;
  // 		}
  // 	}
  // } else if ((cname.length + length) == name.length) {
  // 	return true;
  // }
  // return false;
  return true;
}

function isHasBangsIphone() {
  let flag = false;



  return flag;
}

function isIos() {
  let flag = false;
  uni.getSystemInfo({
    success: function (res) {
      if (res.platform == 'ios') {
        flag = true;
      }
    },
  });
  return flag;
}

function isWXOrDD() {
  let result = false;

  result = true;

  return result;
}

function isSpecialPlat() {
  let pid = plantId || MemberInfo.PlatId;
  if (pid == '1028' || pid == '1029' || pid == '1033' || pid == '1035' || pid == '1040') {
    return true;
  }
  return false;
}

function replaceRegularSymbol(val) {
  val = val.replace(/\\/g, '');
  val = val.replace(/\^/g, '');
  val = val.replace(/\$/g, '');
  val = val.replace(/\*/g, '');
  val = val.replace(/\+/g, '');
  val = val.replace(/\?/g, '');
  val = val.replace(/\'/g, '');
  return val;
}

function formatStr(str) {
  return str
    .replace(/\\n\\r/g, '<br />')
    .replace(/\\n/g, '<br />')
    .replace(/\\s/g, ' ')
    .replace(/\\t/g, '	');
}

function removeFormatStr(str) {
  return (str || '')
    .replace(/\\n\\r/g, '')
    .replace(/\\n/g, '')
    .replace(/\\s/g, '')
    .replace(/\\t/g, '')
    .replace(/<br\s*\/?>/gi, '');
}

function setCustomerNull() {
  let settings = GetSettings();
  CustomerJurisdiction.CanUse = false;
  CustomerJurisdiction.IsTrial = false;
  CustomerJurisdiction.IsManage = 0;
  // settings.IsPermittedUseCar = false;
  settings.MemberInfo = {};
  settings.IsTrial = false;
  settings.isLogin = false;
  settings.IsManage = 0;
  settings.CompanyName = '';
  settings.Customers = [];
  settings.IsApprover = false;
  settings.IsPermittedUseCar = false;
  settings.IsPermittedUseCarTemp = false;
  settings.IsPermittedUseCarWork = false;
  settings.IsPermittedBookHotel = false;
  settings.IsPermittedBookInternationalHotel = false;
  settings.IsPermittedBookFlight = false;
  settings.IsPermittedBookTrain = false;
  settings.IsPermittedBookInternationalFlight = false;
  settings.IsUploadTravelBusinessCertify = false;
  // settings.IsCanValidateBill = false;
  settings.AccountBalance = 0;
  (settings.MemberInfo || {}).CustomerName = '';
  (settings.MemberInfo || {}).EnterpriseId = 0;
  settings.HotelAdvanceDay = 0;
  settings.FlightAdvanceDay = 0;
  settings.IsExpiredContract = false;
  settings.takeoutPeritted = null;
  SetSettings(settings);
}

function getUUId() {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  var uuid = s.join('');
  return uuid;
}

function getIndexPageUrl() {
  let settings = GetSettings();
  if (settings.isOpenBonusPoints) {
    return '/pages/index3.0/index';
  }
  return '/pages/index/index';
}

function checkChineseName(name) {
  if (name[0] == '·' || name[name.length - 1] == '·') {
    return false;
  }
  let str = name.replace(/\s*/g, '').replace(/·*/g, '');
  let pattern = /^[\u4e00-\u9fa5a-z]+$/gi;
  return pattern.test(str);
}

function handlePreLoadPage(urls) {

  if (urls && urls.length > 0) {
    setTimeout(() => {
      urls.forEach((val) => {
        uni.preloadPage({
          url: val,
        });
      });
    }, 1000);
  }

}

function baseLoading() {
  uni.showLoading({
    title: '加载中',
  });
}

async function callPhone(object) {
  const state = await permissionManager.requestApplicationPermission('callPhone');
  if (!state) {
    return;
  }
  uni.makePhoneCall(object);
}

export default {
  MemberInfo,
  CustomerJurisdiction,
  Post,
  request,
  GetSettings,
  SetSettings,
  getLocalStorage,
  setLocalStorage,
  GetResultState,
  Loading,
  Toast,
  Confirm,
  ModalHelper,
  checkCard,
  checkPhone,
  GetQueryString,
  apiUrl,
  webSiteUrl,
  time,
  clearTime,
  timeTrain,
  clearTimeTrain,
  SetTitleColor,
  SetBarTitle,
  checkName,
  isHasBangsIphone,
  hasNet,
  isInNoNetPage,
  HideLoading,
  isIos,
  isWXOrDD,
  isSpecialPlat,
  replaceRegularSymbol,
  removeFormatStr,
  formatStr,
  handlePreLoadPage,
  setCustomerNull: setCustomerNull,
  plantId: plantId,
  refId: refId,
  getUUId: getUUId,
  getIndexPageUrl: getIndexPageUrl,
  checkChineseName: checkChineseName,
  baseLoading,
  callPhone: callPhone,
  getUrlConfig: getUrlConfig,
  apiRequestList: apiRequestList,
  getCurrentWebsiteUrl,
  deletePostParam: deletePostParam,
  checkPostParam: checkPostParam,

  requestCompleteCallback: requestCompleteCallback,

  getLoadBalancingApiUrl,
  getHeaderPlatId,
};
